import angular from 'angular';
import constants from 'app/constants';
import { ecatDataService, ecatSharedModelService, loaderService, ssDialogService } from 'app/services';
import { alerts } from 'app/components/global';
import controller from './confirm-complete-assessment-dialog.controller';
import template from './confirm-complete-assessment-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, templateId, assessmentName, isNavantaUser, users }) {
    return {
      controller,
      controllerAs: 'completeAssessmentConfirmDialogVM',
      locals: {
        assessmentId,
        templateId,
        assessmentName,
        isNavantaUser,
        users,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.advisory.ecat.confirmCompleteAssessmentDialog', [
    alerts,
    constants,
    ecatDataService,
    ecatSharedModelService,
    loaderService,
    ssDialogService,
  ])
  .service('confirmCompleteAssessmentDialog', dialogService).name;
